import { makeAutoObservable } from 'mobx'
import { logoutTokenDestruction, tokenInit } from '@/utils'
import api from './api'
import system from './index'

export default class User {
    static parent
    // 用户凭证
    id = ''
    token = ''
    nickname = ''
    mask = ''
    mobile = ''
    base_info = null
    member_name = '' // 会员名称
    member_icon = ''
    sensors = ''
    businessTypeInfo = {a:1} // 当前业务类型
    // 一个关于用户的承诺 如果有承诺在 说明用户可能正在登录的请求中
    promise = new Promise((resolve, reject) => resolve())
    // 会员信息
    member_info = {}
    layout = {
        showFixBarRight: true,
        useTopbar: true,
        useFotter: true,
        isPage: false,
    }

    updateLayout(layout = {}) {
        Object.keys(layout).forEach(key=> {
            this.layout[key] = layout[key]
        })
    }

    //更新用户昵称
    updateNickName(nickname) {
        this.nickname = nickname
        let user_info = localStorage.getItem('react_user_info')
        if (user_info) {
            try {
                user_info = JSON.parse(user_info)
                user_info.nickname = nickname
                localStorage.setItem('react_user_info', JSON.stringify(user_info))
            } catch (error) {
                console.log('Set react_user_info error:', error);
            }
        }
    }

    // 更新购物车数量
    cartCount = 0
    async updateCartCount() {
        const res = await this.get('/api/office/shopping/car/productCount', {
            userId: this.id,
            timestamp: new Date().getTime()
        })
        if (res.status == 200) {
            this.cartCount = res.data.count
        }
    }


    // 是否显示引导
    get needShowTour() {
        const { needShowTour, userId } = this.base_info || {}
        const id = userId + '_needShowTour';
        return needShowTour===0 && !window.localStorage.getItem(id)
    }

    setNeedShowTourr(visible) {
        const { userId } = this.base_info || {}
        const id = userId + '_needShowTour';
        if(!visible) {
            window.localStorage.setItem(id, false)
        }
    }

    get gender() {
        return this.sex === 1 ? '男' : '女'
    }

    // 当前用户是否登录 通过是否存base_info来判断
    get is_login() {
        return this.base_info !== null
    }

    get config() {
        if (!this.token) {
            return {}
        }

        return {
            headers: {
                token: this.token,
                mtoken: this.token,
                stoken: this.token
            }
        }
    }

    constructor(parent) {
        makeAutoObservable(this)
        this.parent = parent
        this.token =
            this.parent.getCookie('stoken') ||
            this.parent.getCookie('mtoken') ||
            this.parent.getCookie('token')
        this.sensors = this.parent.sensors

        // 如果有token 就说明是登录状态 尝试去缓存中获取用户信息
        if (this.token) {
            let user_info = localStorage.getItem('react_user_info')
            if (user_info) {
                try {
                    user_info = JSON.parse(user_info)
                    if (user_info.token === this.token) {
                        this.injectUserInfo(user_info)
                        // this.promise = this.updateUserInfo(this.token)
                    } else {
                        this.promise = this.updateUserInfo(this.token)
                    }
                } catch (err) {
                    console.error('尝试缓存自动登录错误：', err)
                    this.promise = this.updateUserInfo(this.token)
                }
            } else {
                this.promise = this.updateUserInfo(this.token)
            }
        }
        this.isZhonghe = window.location.host.indexOf('zhongheschool')
        if(~this.isZhonghe) {
            this.businessTypeUpdate({
                businessTypeId: window.location.pathname.startsWith('/fakao') ? '104' : '90'
            })
        }
    }
    // 更新业务类型
    businessTypeUpdate(businessTypeInfo) {
        this.businessTypeInfo = businessTypeInfo;
        if(businessTypeInfo.businessTypeId) {
            this.getBusinessTypeId(businessTypeInfo.businessTypeId)
        }
    }
    // 获取公开课id
    async getBusinessTypeId(businessTypeId) {
        const url = this.isZhonghe ? api.get_open_class_id_zhonghe : api.get_open_class_id_zhuma
        const { status, data } = await this.post(url, { businessTypeId })
        if (status == 200 && data?.id) {
            this.productTypeId = data?.id;
        }
    }
    // 更新用户信息
    async updateUserInfo(token) {
        const res = await this.get1(
            this.parent.api.get_user_infoV2,
            {},
            {
                token: token,
                mtoken: token,
                stoken: token
            }
        )

        if (res.status !== 200 || !res.data) {
            console.error('自动登录失败')
            this.injectUserInfo(null)
        } else {
            // 获取会员信息
            // this.getMemberCenter(token)
            this.injectUserInfo({ ...res.data, token })
        }
    }

    // 获取会员信息
    async getMemberCenter(token) {
        const res = await this.post(
            this.parent.api.member_information,
            {},
            {
                headers: {
                    token: token,
                    mtoken: token,
                    stoken: token
                }
            }
        )

        if (res.status === 200) {
            this.member_info = res.data
        }

        return res
    }

    // 获取老页面的用户信息
    // 暂时不用了
    getOldUserInfo() {
        let user_info = this.parent.getCookie('user_info')
        if (user_info) {
            user_info = decodeURIComponent(user_info)
            if (user_info.indexOf('.') === -1) return user_info
            user_info = user_info.split('.').slice(0, -1).join('.')
            if (user_info.indexOf(':') === -1) return user_info
            user_info = user_info.split(':')
            return user_info.slice(1).join(':')
        }

        return null
    }

    injectUserInfo(user_info) {
        if (!user_info) {
            localStorage.removeItem('user_info')
            localStorage.removeItem('react_user_info')
            this.parent.delCookie('user_info')
            this.parent.delCookie('stoken')
            this.parent.delCookie('mtoken')
            this.parent.delCookie('token')
            this.id = ''
            this.token = ''
            this.nickname = ''
            this.member_name = ''
            this.member_icon = ''
            this.mask = ''
            this.mobile = ''
            this.base_info = null
            return
        }

        this.id = user_info.userId
        this.token = user_info.token || this.token
        this.nickname = user_info.nickname
        this.sex = user_info.sex
        this.mask = user_info.headimgurl
        this.mobile = user_info.mobile
        this.member_name = user_info.memberName
        this.member_icon = user_info.avatarMemberBoxUrl

        this.base_info = user_info
        localStorage.setItem('react_user_info', JSON.stringify(user_info))
        this.parent.setCookie('stoken', encodeURIComponent(this.token))
        this.parent.setCookie('token', encodeURIComponent(this.token))
        this.parent.setCookie('mtoken', encodeURIComponent(this.token))

        // 全局埋点，当用户登录之后获取到用户id时调用（收集用户信息）
        this?.sensors?.login(user_info.userId)
    }

    // 登陆 成功则保存用户信息
    // 多种登录方式下，传入url可以自定义登录接口
    async login({ url, phone_number, code }) {
        const res = await this.post(url || this.parent.api.login, {
            mobile: phone_number,
            code,
            authType: 'sms'
        })
        if (res.status !== 200 || !res.data) {
            if (res.data) {
                return {
                    ...res.data,
                    status: false
                }
            } else {
                return {
                    status: false,
                    msg: res.error || '登录失败'
                }
            }
        } else {
            await this.updateUserInfo(res.data.token)
            // 方便联调 上线删除
            // this.injectUserInfo({ ...res.data})

            const url = tokenInit(res.data.token)
            if (url) {
                await this.get(url)
            }
        }
        return { status: true }
    }

    async qrcodeLogin(qrCode) {
        if (!qrCode)
            return {
                status: 400,
                msg: '二维码错误'
            }

        const res = await this.post(this.parent.api.check_qrcode_login, {
            authType: 'qrCode',
            qrCode
        })
        if (res.status === 200) {
            await this.updateUserInfo(res.data.token)
            const url = tokenInit(res.data.token)
            if (url) {
              await this.get(url)
            }
        }

        return res
    }

    async logout() {
        const res = await this.post(this.parent.api.logout, {
            userId: this.id
        })
        const url = logoutTokenDestruction()
        if (url) {
            await this.get(url)
        }
        if (res.status !== 200) {
            return {
                ...res,
                status: false
            }
        }

        this.injectUserInfo(null)
        return { status: true }
    }

    async get(url, params,config) {
        return await this.parent.axios.get(url, { params, ...this.config },{...config})
    }

    async get1(url, params,headers) {
      return await this.parent.axios.get(url, { params, headers })
    }

    async post(url, data = {}, params = {}) {
        return await this.parent.axios.post(url, data, {
            ...this.config,
            ...params
        })
    }

    async delete(url, data = {}, params = {}) {
        return await this.parent.axios.delete(url, data, {
            ...this.config,
            ...params
        })
    }

    // 竹马post请求
    async zhumaPost(url, data) {
        return await this.parent.node_zhuma_axios.post(url, data, this.config)
    }

    // 竹马get请求
    async zhumaGet(url, params) {
        let config = {}
        if (params) {
            config = {
                ...this.config,
                params
            }
        }
        return await this.parent.node_zhuma_axios.get(url, config)
    }

    // 众合post请求
    async zhonghePost(url, data) {
        return await this.parent.node_zhongheschool_axios.post(
            url,
            data,
            this.config
        )
    }

    // 众合get请求
    async zhongheGet(url) {
        return await this.parent.node_zhongheschool_axios.get(url, this.config)
    }

    // crm 接口调用
    async crmZhonghePost(url, data) {
        return await this.parent.crm_zhongheschool_axios.post(
            url,
            data,
            this.config
        )
    }

    async mockGet(url, params, headers = {}) {
      return await this.parent.mock_axios.get(url, { params, headers })
    }
    async NO_CDN_GET(url, params, headers = {}) {
      return await this.parent.NO_CDN_AXIOS.get(url, { params, headers })
    }

    async NO_CDN_POST(url, data) {
      return await this.parent.NO_CDN_AXIOS.post(
        url,
        data,
        this.config
      )
    }


  async CDN_GET(url, params, headers = {}) {
    return await this.parent.CDN_AXIOS.get(url, { params, headers })
  }

  async CDN_POST(url, data) {
    return await this.parent.CDN_AXIOS.post(
      url,
      data,
      this.config
    )
  }
}
